import { action, observable, makeObservable } from 'mobx';
import { Model, IModelAttributes, attribute, entity } from 'Models/Model';
import * as Models from 'Models/Entities';

export interface IGiftCertificateUsageEntityAttributes extends IModelAttributes {
	usedValue: number;

	giftCertificateId?: string;
	giftCertificate?: Models.GiftCertificateEntity | Models.IGiftCertificateEntityAttributes;
	transactionId?: string;
	transaction?: Models.TransactionEntity | Models.ITransactionEntityAttributes;
}
@entity('GiftCertificateUsageEntity', 'Gift Certificate Usage')
export default class GiftCertificateUsageEntity extends Model implements IGiftCertificateUsageEntityAttributes {
	/**
	 * Fields to exclude from the JSON serialization in create operations.
	 */
	public static excludeFromCreate: string[] = [];

	/**
	 * Fields to exclude from the JSON serialization in update operations.
	 */
	public static excludeFromUpdate: string[] = [];

	@observable
	@attribute<GiftCertificateUsageEntity, number>()
	public usedValue: number;

	@observable
	@attribute()
	public giftCertificateId?: string;

	@observable
	@attribute({ isReference: true, manyReference: false })
	public giftCertificate: Models.GiftCertificateEntity;

	@observable
	@attribute()
	public transactionId?: string;

	@observable
	@attribute({ isReference: true, manyReference: false })
	public transaction: Models.TransactionEntity;

	constructor(attributes?: Partial<IGiftCertificateUsageEntityAttributes>) {
		super(attributes);

		makeObservable(this);

		this.assignAttributes(attributes);
	}

	/**
	 * Assigns fields from a passed in JSON object to the fields in this model.
	 * Any reference objects that are passed in are converted to models if they are not already.
	 * This function is called from the constructor to assign the initial fields.
	 */
	public assignAttributes(attributes?: Partial<IGiftCertificateUsageEntityAttributes>) {
		super.assignAttributes(attributes);

		if (attributes) {
			if (attributes.usedValue !== undefined) {
				this.usedValue = attributes.usedValue;
			}
			if (attributes.giftCertificateId !== undefined) {
				this.giftCertificateId = attributes.giftCertificateId;
			}
			if (attributes.giftCertificate !== undefined) {
				if (attributes.giftCertificate === null) {
					this.giftCertificate = attributes.giftCertificate;
				} else if (attributes.giftCertificate instanceof Models.GiftCertificateEntity) {
					this.giftCertificate = attributes.giftCertificate;
					this.giftCertificateId = attributes.giftCertificate.id;
				} else {
					this.giftCertificate = new Models.GiftCertificateEntity(attributes.giftCertificate);
					this.giftCertificateId = this.giftCertificate.id;
				}
			}
			if (attributes.transactionId !== undefined) {
				this.transactionId = attributes.transactionId;
			}
			if (attributes.transaction !== undefined) {
				if (attributes.transaction === null) {
					this.transaction = attributes.transaction;
				} else if (attributes.transaction instanceof Models.TransactionEntity) {
					this.transaction = attributes.transaction;
					this.transactionId = attributes.transaction.id;
				} else {
					this.transaction = new Models.TransactionEntity(attributes.transaction);
					this.transactionId = this.transaction.id;
				}
			}
		}
	}
}
